import { RouteType } from "types/RouteType";

/**
 * `/login` — the sign-in address from before the auth routes moved under the
 * library's `/auth` layout (`/auth/login`, route "Login Page").
 *
 * Bookmarks, password-manager entries and old links still point at `/login`.
 * Unmatched, the library's first-load logic lands them on NotFound with a
 * "Page not found: /login" warning toast stacked over the sign-in form — the
 * walkthrough audit's `001_Login_page` frame
 * (plan/2026-09-28_walkthrough-5x5-audit.md §3.5). This alias forwards them to
 * the real route instead, keeping any query string (e.g. `?passwordRecovery`).
 *
 * It is not a fork of the library's auth routes (views/authRoutes.test.ts pins
 * that there is none): it renders nothing and owns no auth behaviour.
 */
const legacyLoginRoute: RouteType = {
  name: "Legacy Login",
  path: "/login",
  layout: "",
  requiresAuth: false,
  requiresAdmin: false,
  requiresPermission: false,
  enableAutoFind: false,
  offlineCapable: false,
  hidden: true,
  beforeEnter: ({ rootStore, queryParams }) => {
    void rootStore.routerStore?.goTo("Login Page", {}, queryParams);
    return false;
  },
};

export default legacyLoginRoute;
